import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Tapybl AI',
  subtitle: 'Powered by AI, driven by you',
  newAssistant: 'New assistant',
  assigned: 'Assigned',
  test: 'Test',
  edit: 'Edit',
  share: 'Share',
  delete: 'Delete',
  copy: 'Copy link',
  shareUrlTitle: 'Share AI assistant',
  shareUrlSubtitle1: 'Copy the URL to embed in your app or iframe.',
  shareUrlSubtitle2: 'Only enrolled learners can access it.',
  shareUrlCopied: 'AI assistant’s URL copied to clipboard!',
  visibilityOFF: 'Users can no longer access this AI assistant',
  visibilityON: 'Users can now access this AI assistant',
  assistantDeleted: 'AI assistant deleted',
  confirmDelete: 'Are you sure you want to delete this AI assistant?',
  emptyState1: 'Oops! Looks like you haven’t added any assistants yet.',
  emptyState2: 'Let’s get started by creating your first assistant now!',
  assistantIsProcessingCreate: 'AI assistant is being created...',
  assistantIsProcessingUpdate: 'AI assistant is being updated...',
};

const welsh = {
  title: 'Cynorthwyydd AI',
  subtitle: 'Gyrru gan AI, dan eich dylanwad chi',
  newAssistant: 'Cynorthwyydd newydd',
  assigned: 'Wedi’i aseinio',
  test: 'Prawf',
  edit: 'Golygu',
  share: 'Rhannu',
  delete: 'Dileu',
  copy: 'Copïo dolen',
  shareUrlTitle: 'Rhannu cynorthwyydd AI',
  shareUrlSubtitle1: 'Copïwch yr URL i’w fewnosod yn eich ap neu iframe.',
  shareUrlSubtitle2: 'Dim ond dysgwyr sydd wedi cofrestru all ei gyrchu.',
  shareUrlCopied: 'URL y cynorthwyydd AI wedi’i gopïo i’r clipfwrdd!',
  visibilityOFF: 'Ni all defnyddwyr gyrchu’r cynorthwyydd AI hwn mwyach',
  visibilityON: 'Gall defnyddwyr gyrchu’r cynorthwyydd AI hwn nawr',
  assistantDeleted: 'Cynorthwyydd AI wedi’i ddileu',
  confirmDelete:
    'Ydych chi’n siŵr eich bod eisiau dileu’r cynorthwyydd AI hwn?',
  emptyState1:
    'Wps! Ymddengys nad ydych wedi ychwanegu unrhyw gynorthwywyr eto.',
  emptyState2: 'Gadewch i ni ddechrau drwy greu eich cynorthwyydd cyntaf nawr!',
  assistantIsProcessingCreate: 'Mae’r cynorthwyydd AI yn cael ei greu...',
  assistantIsProcessingUpdate: 'Mae’r cynorthwyydd AI yn cael ei ddiweddaru...',
};

export const aiAssistantText: any = getLocalizationBasedOnLang(english, welsh);
